module.exports = __webpack_public_path__ + "img/2_29.5dc8fedb.png";